import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Cookies() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("cookiesPage.title", "Cookie Policy")}
      subtitle={t("cookiesPage.subtitle", "Last updated: July 2026")}
    >
      <div className="space-y-8 text-slate-300">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.whatTitle", "What Are Cookies?")}</h2>
          <p>{t("cookiesPage.whatText", "Cookies are small files stored on your device that help us recognize you and provide a better experience. They're a standard web technology used by virtually all websites.")}</p>
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.typesTitle", "Types of Cookies We Use")}</h2>
          {["essential", "performance", "preference", "marketing"].map((key) => (
            <div key={key} className="mb-4 rounded-lg border border-slate-700 bg-slate-800/30 p-4">
              <h3 className="mb-2 font-semibold text-blue-300">{t(`cookiesPage.${key}Title`, key)}</h3>
              <p className="text-sm">{t(`cookiesPage.${key}Text`, "")}</p>
            </div>
          ))}
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.thirdPartyTitle", "Third-Party Cookies")}</h2>
          <p>{t("cookiesPage.thirdPartyText", "We may allow third parties (such as analytics providers and advertising networks) to place cookies on your device. These are governed by their own privacy policies.")}</p>
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.choicesTitle", "Your Cookie Choices")}</h2>
          <p className="mb-3">{t("cookiesPage.choicesIntro", "You can control cookies in several ways:")}</p>
          <ul className="space-y-2">
            {["browser", "preferences", "optOut"].map((key) => (
              <li key={key} className="flex gap-3">
                <span className="text-blue-400">→</span>
                <span>
                  <strong>{t(`cookiesPage.choices.${key}.label`, "")}</strong>{" "}
                  {t(`cookiesPage.choices.${key}.text`, "")}
                </span>
              </li>
            ))}
          </ul>
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.noteTitle", "Important Note")}</h2>
          <p>{t("cookiesPage.noteText", "Disabling essential cookies may prevent PartyBuddy from functioning properly. You'll still be able to use the site, but your experience may be limited.")}</p>
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.changesTitle", "Changes to This Policy")}</h2>
          <p>{t("cookiesPage.changesText", `We may update this Cookie Policy from time to time. We'll notify you of any changes by updating the "Last updated" date at the top of this page.`)}</p>
        </section>
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">{t("cookiesPage.questionsTitle", "Questions?")}</h2>
          <p>{t("cookiesPage.questionsText", "For questions about our use of cookies, please contact us at")} <a href="mailto:privacy@partybuddy.app" className="text-blue-400 transition hover:text-blue-300">privacy@partybuddy.app</a></p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Cookies;
